<template>
  <div>
    <CustomizeUrlInformation
      @dialog-closed="openCustomizeUrlInformation = false"
      v-if="openCustomizeUrlInformation"
    />
    <Step :step="{ title: t('landingpages.steps.step-2.title') }">
      <template #content>
        <span class="text pt-2">{{ t('landingpages.steps.step-2.content.0') }}</span>
        <a
          v-if="originalUrl"
          @click="$tracking.event('Landingpages', 'Clicked', 'Original Url')"
          :href="originalUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="d-inline-block text-truncate my-3"
        >
          <span class="link-text text-decoration-underline text-wrap">{{ prettyOriginalUrl }}</span>
        </a>
        <span
          v-if="!customUrl"
          class="text"
          >{{ t('landingpages.steps.step-2.content.2') }} <br /><br
        /></span>
        <a
          v-if="!customUrl"
          :href="helpLinks.customUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="d-inline-block text-truncate mb-1"
          @click="$tracking.event('Landingpages', 'Clicked', 'Custom Url')"
        >
          <span class="link-text text-decoration-underline text-wrap">
            {{ t('landingpages.steps.step-2.content.3') }} </span
          ><br />
        </a>
        <span
          v-if="customUrl"
          @click="$tracking.event('Landingpages', 'Clicked', 'Custom Url')"
        >
          <span class="text"> {{ t('landingpages.steps.step-2.content.4') }} </span><br /><br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            :href="customUrl"
            class="d-inline-block text-truncate"
          >
            <span class="link-text"> {{ prettyCustomUrl }}</span>
          </a>
        </span>
        <span v-else>
          <v-btn
            class="button mt-2"
            color="white"
            elevation="0"
            @click="openCustomizeUrlInformation = true"
          >
            <v-icon
              width="24"
              height="24"
              color="primary"
              class="mr-1"
            >
              mdi-pencil-outline
            </v-icon>
            <span class="button-text">{{ t('landingpages.steps.step-2.button-label') }}</span>
          </v-btn>
        </span>
      </template>
    </Step>
  </div>
</template>

<script lang="ts" setup>
import { getCurrentInstance, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import helpLinks from '@/lib/helpLinks'
import CustomizeUrlInformation from '@/modules/landingpage/CustomizeUrlInformation.vue'
import Step from '@/modules/landingpage/steps/Step.vue'

const { t } = useI18n()

const instance = getCurrentInstance()
const $tracking = instance?.proxy?.$tracking

const openCustomizeUrlInformation = ref(false)

defineProps<{
  originalUrl?: string
  prettyOriginalUrl?: string
  customUrl?: string
  prettyCustomUrl?: string
}>()
</script>

<style scoped>
.text {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.link-text {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.button-text {
  color: #175e51;
  text-align: center;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

@media (max-width: 960px) {
  .button {
    width: 100%;
  }
}
</style>
